import { render, staticRenderFns } from "./PaginationNew.vue?vue&type=template&id=2de9c606&scoped=true"
import script from "./PaginationNew.vue?vue&type=script&lang=js"
export * from "./PaginationNew.vue?vue&type=script&lang=js"
import style0 from "./PaginationNew.vue?vue&type=style&index=0&id=2de9c606&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de9c606",
  null
  
)

export default component.exports